import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from '../src/components/Home/Home.jsx';
// import PaseosAereos from './components/PaseosAereos/PaseosAereos.jsx';
import About from '../src/components/About/About.jsx';
import Industries from './components/Industries/Industries.jsx';
import Products from './components/Products/Products.jsx';
import ProductDetail from './components/ProductDetail/ProductDetail.jsx';
import 'bootstrap/dist/css/bootstrap.min.css';


function App() {

  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          {/* <Route path='/paseos-turisticos' element={<PaseosAereos />} /> */}
          <Route path='/nosotros' element={<About />} />
          <Route path='/industrias' element={<Industries />} />
          <Route path='/productos' element={<Products />} />
          <Route path="/productos/:id" element={<ProductDetail />} />
          <Route path='*' element={<Home />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
